import { LDSHeading } from "@resmed/lumina-design-system";

export const SectionLabel = ({ label }: { label: string }) => (
  <div className="lds-px-4 lds-py-1.5">
    <LDSHeading
      size="h5"
      className="lds-text-xs lds-font-semibold lds-text-textcolor-caption lds-uppercase lds-tracking-wide"
    >
      {label}
    </LDSHeading>
  </div>
);
